import React from "react";
import { connect } from "react-redux";
import LicensedBook from "../../book/licensed-book";
import { withTheme } from "styled-components";
import GridView from "../../../../components/gridview/GridView";
import { EDGE_SPACING } from "../consts";
import { t } from "../../../../core/translate";
import { selectors as ancillarySelectors } from "../../../../../redux/ancillaries";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { selectors as feenySelectors } from "../../../../../redux/feeny";
import { selectors as booksSelectors } from "../../../../../redux/books";
import GridFilter from "./grid-filter";
import CollectionsLane from "./collections";
import {
  selectors as collectionsSelectors,
  actions as collectionsActions
} from "../../../../../redux/collections";
import PageTitle from "../../../../utils/page-title";
import { gaEvent } from "../../../../utils/analytics";

class BookGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appliedFilter: {
        assignments: false,
        resources: false,
        courseware: false
      },
      collections: []
    };
  }

  componentDidMount() {
    this.props.fetchCollections();
  }

  renderBook = ({ index, item, width, height, BookObject = LicensedBook }) => {
    return (
      <BookObject
        isbn={item}
        width={width}
        height={height}
        context={`grid-${this.props.headerLabel}`}
        index={index}
      />
    );
  };

  appliedFilter = buttonID => {
    this.setState({
      appliedFilter: {
        ...this.state.appliedFilter,
        [buttonID]: !this.state.appliedFilter[buttonID]
      }
    });
  };

  applyCollections = collection => {
    this.setState(prevState => ({
      collections: [collection, ...prevState.collections]
    }));
    gaEvent("CollectionsClick");
  };

  getFilterToIsbns = () => {
    const { assignments, resources, courseware } = this.state.appliedFilter;
    const { collections } = this.state;
    const isbns =
      collections.length > 0 ? collections[0].books : this.props.isbns;
    return isbns.filter(isbn => {
      if (this.props.isbns.indexOf(isbn) === -1) {
        return false;
      }
      if (resources && this.props.resourcesIsbns.indexOf(isbn) >= 0) {
        return true;
      }
      if (courseware && this.props.coursewareIsbns.indexOf(isbn) >= 0) {
        return true;
      }

      return !assignments && !resources && !courseware;
    });
  };

  renderCollections = () => {
    const { collections } = this.state;
    const currentCollection =
      collections.length > 0 ? collections[0].children : this.props.collections;
    return currentCollection.map((collection, index) => {
      return {
        title: collection.title,
        count: collection.books.length,
        books: collection.books,
        onClick: () => this.applyCollections(collection)
      };
    });
  };

  getHeaderLabel = () => {
    const { headerLabel } = this.props;
    const { collections } = this.state;
    return collections.length > 0 ? collections[0].title : headerLabel;
  };

  getLastLabel = () => {
    const { collections } = this.state;
    if (collections.length > 1) {
      return collections[1].title;
    } else if (collections.length < 1) {
      return t("main-menu.library", "Library");
    }
    return t("filter.my-books", "My books");
  };

  onHeaderClick = () => {
    const { onHeaderClick } = this.props;
    const { collections } = this.state;
    if (collections.length > 0) {
      this.setState(prevState => ({
        collections: prevState.collections.slice(1)
      }));
    } else {
      onHeaderClick();
    }
  };

  buildFilters = () => {
    const { ancillarySummary, showPillButtons } = this.props;
    const filterButtons = [];
    if (ancillarySummary.ancillariesCount > 0 && showPillButtons) {
      filterButtons.push({
        buttonID: "resources",
        buttonText: t("filter.resources", "Resources"),
        buttonClick: () => this.appliedFilter("resources"),
        selected: this.state.appliedFilter["resources"]
      });
    }
    if (ancillarySummary.accessCodeCount > 0 && showPillButtons) {
      filterButtons.push({
        buttonID: "courseware",
        buttonText: t("eresourses.courseware", "Courseware"),
        buttonClick: () => this.appliedFilter("courseware"),
        selected: this.state.appliedFilter["courseware"]
      });
    }
    return filterButtons;
  };

  render() {
    const {
      isCollectionsFetching,
      showCollections,
      showBrandedCollections,
      backArrow,
      totalBookCount
    } = this.props;
    const filterButtons = this.buildFilters();
    const gridBooks = this.getFilterToIsbns();
    return (
      <div>
        <PageTitle
          title={t("library.library-category", "Library Category", {
            category: this.getHeaderLabel()
          })}
        />
        <GridFilter
          onHeaderClick={this.onHeaderClick}
          headerLabel={this.getHeaderLabel()}
          filterButtons={filterButtons}
          backArrow={backArrow}
          lastLabel={this.getLastLabel()}
          filtersOn={
            showCollections && showBrandedCollections && totalBookCount >= 10
          }
        />
        <CollectionsLane
          collections={this.renderCollections()}
          isFetching={isCollectionsFetching}
          items={gridBooks}
          enabled={
            showCollections && showBrandedCollections && totalBookCount >= 10
          }
        />
        <GridView
          items={gridBooks}
          renderItem={this.renderBook}
          inset={EDGE_SPACING}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  ancillarySummary: ancillarySelectors.getAncillarySummary(state),
  assignmentIsbns: feenySelectors.getUserAssignmentsIsbns(state),
  resourcesIsbns: ancillarySelectors.getIsbnsWithAncillaries(state),
  coursewareIsbns: ancillarySelectors.getIsbnsWithAccessCodes(state),
  collections: collectionsSelectors.getCollections(state),
  isCollectionsFetching: collectionsSelectors.isCollectionsFetching(state),
  showBrandedCollections: brandSelectors.getBrandValue(
    state,
    "Library.collections"
  ),
  totalBookCount: booksSelectors.getIsbns(state).length
});

const mapDispatchToProps = dispatch => ({
  fetchCollections: () => dispatch(collectionsActions.fetchCollections())
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(BookGrid)
);
